import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { I18nModule } from '@spartacus/core'
import { SpinnerModule } from '@spartacus/storefront'
import { MaterialModule } from '../../shared/material.module'
import { SharedModule } from '../../shared/shared.module'
import { CustomDeliveryModeComponent } from './custom-delivery-mode.component'

@NgModule({
  declarations: [CustomDeliveryModeComponent],
  imports: [CommonModule, ReactiveFormsModule, I18nModule, SpinnerModule, MaterialModule, SharedModule],
  providers: [
    // provideConfig(<CmsConfig>{
    //   cmsComponents: {
    //     CheckoutDeliveryMode: {
    //       component: CustomDeliveryModeComponent,
    //       guards: [CheckoutAuthGuard, CartNotEmptyGuard],
    //     },
    //   },
    // }),
  ],
  exports: [CustomDeliveryModeComponent]
})
export class CustomDeliveryModeModule {}
